import ReactDOM from "react-dom";
import icons from "../lib/icons";
import { useState } from "react";

const InformationTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);

  const modalContent = (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50"
      onClick={() => setIsOpen(false)}
    >
      <div className="flex flex-col bg-zinc-800 p-4 rounded-md w-[350px] text-zinc-300 text-[24x]">
        <span>
          کاربر گرامی توجه داشته باشید که منظور حفظ کارایی سیستم درصورت عدم
          انتخاب بازه‌ی زمانی مشخص برای خروجی اکسل، تنها اطلاعات مربوط به روز
          اخیر نمایش داده خواهد شد.
          <br />
          همچنین، دقت کنید که بازه‌ی انتخابی نمی‌تواند بیشتر از یک ماه باشد.
        </span>
      </div>
    </div>
  );

  return (
    <div>
      <button
        onClick={() => setIsOpen(true)}
        className="bg-[#F6D6D6] p-1 rounded-md"
      >
        <img src={icons.info} alt="Info" className="w-7 h-7" />
      </button>

      {isOpen && ReactDOM.createPortal(modalContent, document.body)}
    </div>
  );
};

export default InformationTooltip;
